<template>
  <div v-transfer-dom v-show="visible" @click="onWrapClick">
    <div v-show="visible" :class="maskClasses" :style="{zIndex}"></div>
    <div v-show="visible" :class="mainClass" :style="{zIndex}">
      <div :class="wrapClasses" :style="mainStyles">
        <transition :name="transitionNames[0]">
          <div v-show="visible" ref="content" :class="[prefixCls + '-content']" :style="heightStyle">
            <div v-if="showHead" :class="[prefixCls + '-header']">
              <slot name="header">
                <div :class="[prefixCls + '-title']" v-html="title"></div>
              </slot>
              <div v-if="closable" class="close" @click="$_onCancel">
                <slot name="close">
                  <span>×</span>
                </slot>
              </div>
            </div>
            <div ref="modal-body" :class="[prefixCls + '-body']" :style="noPadding?'padding:0':''">
              <slot></slot>
            </div>
            <div v-if="!footerHide" :class="[prefixCls + '-footer']">
              <slot name="footer">
                <t-button type="secondary" @click.native="$_onCancel">{{ localeCancelText }}</t-button>
                <t-button :loading="buttonLoading" type="primary" @click.native="$_onOk">{{ localeOkText }}</t-button>
              </slot>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable indent */

import Icon from '../icon'
import TButton from '../button/button.vue'
import TransferDom from '../../directives/transfer-dom'
import Locale from '../../mixins/locale'
import Emitter from '../../mixins/emitter'
const MIN_LAYER = 1050 // 此值来自aid-elements工程中的 _variable.scss中定义的层级
const PREFIX_MODAL_CLASS = 'modal'
let layer = MIN_LAYER

export default {
  name: 'Modal',
  components: { Icon, TButton },
  directives: { TransferDom },
  mixins: [Locale, Emitter],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: true
    },
    maskClosable: {
      type: Boolean,
      default: true
    },
    title: {
      type: String
    },
    width: {
      type: [Number, String],
      default: 520
    },
    height: {
      type: [Number, String],
      default: ''
    },
    okText: {
      type: String
    },
    cancelText: {
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    },
    styles: {
      type: Object
    },
    className: {
      type: String
    },
    footerHide: {
      type: Boolean,
      default: false
    },
    transitionNames: {
      type: Array,
      default() {
        return ['ease', 'fade']
      }
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    resetScroll: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      prefixCls: PREFIX_MODAL_CLASS,
      wrapShow: false,
      showHead: true,
      buttonLoading: false,
      visible: this.value,
      zIndex: MIN_LAYER
    }
  },
  computed: {
    mainClass() {
      return `${PREFIX_MODAL_CLASS} d-block show`
    },
    wrapClasses() {
      return [
        `${PREFIX_MODAL_CLASS}-dialog`,
        {
          [`${this.className}`]: !!this.className
        }
      ]
    },
    maskClasses() {
      return `${PREFIX_MODAL_CLASS}-backdrop fade show`
    },
    classes() {
      return `${PREFIX_MODAL_CLASS}-content`
    },
    mainStyles() {
      let style = {}
      const styleWidth = {
        width: `${this.width}px`
      }
      const customStyle = this.styles ? this.styles : {}
      Object.assign(style, styleWidth, customStyle)
      return style
    },
    heightStyle() {
      return {
        height: this.height ? `${this.height}px` : 'auto'
      }
    },
    localeOkText() {
      if (this.okText === undefined) {
        return this.t('t.modal.okText')
      } else {
        return this.okText
      }
    },
    localeCancelText() {
      if (this.cancelText === undefined) {
        return this.t('t.modal.cancelText')
      } else {
        return this.cancelText
      }
    }
  },
  watch: {
    value(val) {
      this.visible = val
    },
    visible(val) {
      this.zIndex = layer
      if (val === false) {
        this.buttonLoading = false
        this.timer = setTimeout(() => {
          this.wrapShow = false
        }, 300)
        document.body.style.overflow = ''
        layer -= 1
      } else {
        if (this.timer) clearTimeout(this.timer)
        this.wrapShow = true
        document.body.style.overflow = 'hidden'
        layer += 1
      }
      this.broadcast('TTable', 'on-visible-change', val)
      if (this.resetScroll) {
        this.$refs['modal-body'].scrollTop = 0
      }
    },
    loading(val) {
      if (!val) {
        this.buttonLoading = false
      }
    },
    title(val) {
      if (this.$slots.header === undefined) {
        this.showHead = !!val
      }
    }
  },
  mounted() {
    if (this.visible) {
      this.wrapShow = true
    }
    let showHead = true
    if (this.$slots.header === undefined && !this.title) {
      showHead = false
    }
    this.showHead = showHead
    // ESC close
    document.addEventListener('keydown', this.$_onEscClose)
  },
  beforeDestroy() {
    document.body.style.overflow = ''
    document.removeEventListener('keydown', this.$_onEscClose)
  },
  methods: {
    onWrapClick(event) {
      if (this.$refs.content && this.$refs.content.contains(event.target) === true) {
        return false
      } else {
        if (this.maskClosable) {
          this.$_onCancel()
        }
      }
    },
    $_onOk() {
      if (this.loading) {
        this.buttonLoading = true
      } else {
        this.visible = false
        this.$emit('input', false)
      }
      this.$emit('on-ok')
    },
    $_onCancel() {
      if (this.visible) {
        this.visible = false
        this.$emit('input', false)
        this.$emit('on-cancel')
      }
    },
    // 使用esc键来关闭
    $_onEscClose(e) {
      if (this.visible && this.closable) {
        if (e.keyCode === 27) {
          this.$_onCancel()
          document.body.click() // esc 会导致以click方式打开的poptip没有销毁
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// modal.vue?4752e208